import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Error,
  Loading,
  ViewTitle,
} from '@iarc-programing/emanufac-components/src/components';
import {
  Button,
  Card,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';

import * as actions from '@/redux/actions';

/**
 * @function WithdrawDestination
 * @description Display a collections or a list of WithdrawDestination from database
 */

export default function WithdrawDestinations({ title, subtitle }) {
  const dispatch = useDispatch();
  const withdrawDestination = useSelector((state) => state.withdrawDestination);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);
  const [name, setName] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [total, setTotal] = useState(undefined);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setName(searchTerm);
      setPage(1);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const queryDataFromServer = async () => {
    try {
      dispatch(actions.withdrawDestinationAll({ name, page, size }));
    } catch (error) {
      dispatch(actions.withdrawDestinationError());
    }
  };

  useEffect(() => {
    queryDataFromServer();
    return () => {};
  }, [name, page, size]);

  useEffect(() => {
    setTotal(withdrawDestination?.total);

    return () => {};
  }, [withdrawDestination]);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  if (withdrawDestination.isLoading) {
    return <Loading />;
  }

  if (!withdrawDestination.isLoading && withdrawDestination.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <Card>
          <div className="p-4 flex flex-row">
            <div className="w-full md:w-1/2">
              <TextField
                label="ค้นหา"
                fullWidth
                size="small"
                id="outlined-start-adornment"
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <i className="fas fa-search"></i>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </div>
        </Card>
        <div className="my-2">
          <Paper>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <div className="font-bold">ลำดับที่</div>
                    </TableCell>
                    <TableCell>
                      <div className="font-bold">ชื่อเป้าหมาย</div>
                    </TableCell>
                    <TableCell>
                      <div className="font-bold">ดำเนินการ</div>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!_.isEmpty(withdrawDestination?.rows) ? (
                    _.map(withdrawDestination?.rows, (row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          <div className="text-xs">{index + 1}</div>
                        </TableCell>
                        <TableCell>{row?.name}</TableCell>
                        <TableCell>
                          <Link
                            to={`/ims/withdraw-destination/view/${row?._id}`}
                          >
                            <Button
                              variant="contained"
                              color="info"
                              size="small"
                            >
                              รายละเอียด
                            </Button>
                          </Link>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6}>
                        <div className="text-center">ไม่มีข้อมูล</div>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              page={page - 1}
              count={total || 1}
              rowsPerPage={size}
              onPageChange={(event, newValue) => {
                setPage(newValue + 1);
              }}
              onRowsPerPageChange={(event) => {
                setSize(event.target.value);
                setPage(1);
              }}
            />
          </Paper>
        </div>
      </div>
    );
  }
  return <Error />;
}

WithdrawDestinations.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

WithdrawDestinations.defaultProps = {
  title: '',
  subtitle: '',
};
